"use strict";

Object.defineProperty(exports, "__esModule", {
     value: true
});
var labels = exports.labels = {
     MedSalePrice: "Median Sale Price",
     SoldCount: "Closed Sales",
     InventoryCount: "New Homes",
     SoldMedDOM: "DOM",
     AvgSalePricePerSqft: "Avg Price/SqFt",
     ActiveCount: "ActiveCount",
     MedSalePricePerSqft: "Med Price/SqFt"
};


//////////////////
// WEBPACK FOOTER
// ./~/react-aculistkpiwidget/lib/labels.js
// module id = 215
// module chunks = 0